import { useParams } from "react-router-dom";
import { PrizeTypeForm } from "./components";
import { prizeTypeService } from "@/frontend/services";
import type { PrizeTypeResponseDTO } from "@/shared/dto";
import { useGetId } from "@/frontend/hooks/useGetId";
import { Spin } from "@/frontend/components/common";

export function UpdatePrizeTypePage() {
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useGetId<PrizeTypeResponseDTO>({
    fetchFn: prizeTypeService.getById,
    redirectUrl: "/prize-types",
    errorMessage: "Error al cargar el tipo de premiación",
    id,
  });

  if (loading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm w-full">
        <div className="flex justify-center items-center py-12">
          <Spin size="large" tip="Cargando..." />
        </div>
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm w-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Editar tipo de premiación</h2>
        <p className="text-gray-600 mt-1">Modifica la información del tipo de premiación</p>
      </div>
      <PrizeTypeForm
        prizeTypeId={id}
        initialValues={{
          name: data.name,
          description: data.description || "",
        }}
      />
    </div>
  );
}
